import React from "react";

import {
  Button,
  Description,
  DescriptionButtonsWrapper,
  DescriptionWrapper,
  DescriptionWrapperRow,
  Icon,
  Quantity,
  RowWrapper,
  SelectorWrapper,
  Title,
} from "./styles";
import { SelectorRowProps } from "./types";

/**
 * Componente SelectorRow
 *
 * Exibe uma linha interativa com controles de incremento e decremento.
 *
 * @param {string} title - Rótulo do item exibido ao lado do ícone.
 * @param {React.ReactNode} icon - Ícone representativo exibido antes do rótulo.
 * @param {number} value - Valor atual exibido no seletor.
 * @param {number} min - Valor mínimo permitido para o seletor.
 * @param {number} max - Valor máximo permitido para o seletor.
 * @param {() => void} onIncrement - Callback executado ao clicar no botão de incremento.
 * @param {() => void} onDecrement - Callback executado ao clicar no botão de decremento.
 */
export const SelectorRow: React.FC<SelectorRowProps> = ({
  title,
  description,
  icon,
  value,
  min,
  max,
  onIncrement,
  onDecrement,
}) => {
  return (
    <RowWrapper>
      <SelectorWrapper>
        <DescriptionWrapper>
          <DescriptionWrapperRow>
            <Icon>{icon}</Icon>
            <Title>{title}</Title>
          </DescriptionWrapperRow>
          <Description>{description}</Description>
        </DescriptionWrapper>
        <DescriptionButtonsWrapper>
          <Button
            disabled={value <= min}
            onClick={onDecrement}
            aria-label={`Decrement ${title}`}
          >
            –
          </Button>
          <Quantity aria-live="polite">{value}</Quantity>
          <Button
            disabled={value >= max}
            onClick={onIncrement}
            aria-label={`Increment ${title}`}
          >
            +
          </Button>
        </DescriptionButtonsWrapper>
      </SelectorWrapper>
    </RowWrapper>
  );
};
